<template>
  <WidgetCard title="Blackout coverage" icon="calendar" :loading="loading" :error="error">
    <template v-if="!loading && !error && data">
      <div class="dw-sevcards dw-sevcards--2">
        <div class="dw-sevcard" :style="{ background: '#FF5A00' }">
          <div class="dw-sevcard__n">
            {{ active.toLocaleString() }}
          </div>
          <div class="dw-sevcard__t">
            ACTIVE
          </div>
        </div>
        <div class="dw-sevcard dw-sevcard--plain">
          <div class="dw-sevcard__n">
            {{ inactive.toLocaleString() }}
          </div>
          <div class="dw-sevcard__t">
            NOT IN BLACKOUT
          </div>
        </div>
      </div>
    </template>
  </WidgetCard>
</template>

<script>
  import WidgetCard from './WidgetCard.vue';

  export default {
    name: 'BlackoutCoverageWidget',
    components: { WidgetCard },
    props: {
      data: { type: Object, default: null },
      loading: { type: Boolean, default: false },
      error: { type: [Boolean, String], default: false }
    },
    computed: {
      // URLs currently under a blackout window.
      active() {
        return this.data ? Number(this.data.in_progress) || 0 : 0;
      },
      total() {
        return this.data ? Number(this.data.total_urls) || 0 : 0;
      },
      // Everything not currently in blackout; active + inactive == total.
      inactive() {
        return Math.max(0, this.total - this.active);
      }
    }
  };
</script>
